'use client';
import { useClient } from '../../hooks/useClient';
import { clientCookies } from '../../utils/cookies';
import { IdentityClaims, parseIdentityToken } from './shared';

export function useIdentity(): IdentityClaims | undefined {
  const identityToken = useClient(() => clientCookies().get('id_token')?.value);
  if (identityToken) {
    return parseIdentityToken(identityToken);
  }
  return undefined;
}
